import {HTMLPrinter} from "@k/global/htmlprinter";
import globalsObject from "../globalsObject";

export class RahmenTabsStaticFunctions {

    static selObCreatedEventHandler() {
        RahmenTabsStaticFunctions.blockEverythingExcept3DViewer();
        $("#shirt").css("cursor", "crosshair");
        $("#textNew").val("");
        $("#textFix").prop("checked", false);
    }

    static blockEverythingExcept3DViewer(){
        $("#blockingOverlay").show();
        $("#toolbox").hide();
        $("#save_draft").hide();
    }

    static unblockAll(){
        $("#blockingOverlay").hide();
        $("#toolbox").show();
        $("#save_draft").show();
        // ($("body") as any).unblock();
    }

    static selObInsertedEventHandler() {
        RahmenTabsStaticFunctions.unblockAll();
        $('#shirt').css('cursor', 'default');
    }

    static createImageUrlFromBlob(blob:Blob) {
        const urlCreator = window.URL || window.webkitURL;
        return urlCreator.createObjectURL(blob);
    }

    static clearMailVorbelegungen() {
        $(["#contactHelp_email", "#contactHelp_telefon", "#contact_email", "#contact_telefon", "#feedBackOwnEmail", "#help_ansprechpartner"].join(",")).val("");
    }

    static setAmountFuerPreisanzeige (amount:any) {
        if (!isNaN(amount) && amount !== "") {
            $("#AmountFuerPreis").val(amount);
            globalsObject.actionController.getPreis(amount, globalsObject.controller.model.getLand());
        }
    }

    static setDomElementHasClassName (domElement : JQuery<HTMLElement>, className : string, shouldBeSet : boolean) {
        if (shouldBeSet) {
            domElement.addClass(className);
        } else {
            domElement.removeClass(className);
        }
    }

    private static sortByTabIndex(a:{tabIndex:number},b:{tabIndex:number}) {
        return ((a.tabIndex > 0) ? a.tabIndex : 1000) - ((b.tabIndex > 0) ? b.tabIndex : 1000);
    }

    static nextOnTabIndex (element : JQuery) : JQuery{
        const fields = $($('a[href], button, input, select, textarea')
            .filter(':visible').filter('a, :enabled')
            .toArray()
            .sort(RahmenTabsStaticFunctions.sortByTabIndex));

        return (fields as unknown as JQuery<HTMLElement>).eq((fields.index(element) + 1) % fields.length);
    }

    static activateExemplarDaten(){
        $(".hide-when-warenkorbdesignchange").addClass("ele-hidden");
        $("#changeWarenkorbItem").removeClass("ele-hidden");
        $(".right-side").addClass("change-item");
    }

    static dirtyKundenKonfiHack(konfi:string){
        const p = HTMLPrinter;
        switch (konfi.toLowerCase()){
            case "11freunde":
                $(".preiszusatz").empty().html(
                    p.collection(
                        p.spanWithProps(
                            p.dataProp("localize")("konf_Preisinfos"),
                            p.style(p.CSSprop("color"), "#00639E")
                        )(" "),
                        p.br,
                        p.spanWithProps(p.dataProp("localize")("konfi_inklMWST"))(" ")
                    )
                );
                break;
            default:
        }
    }

    public static getFunktionalitaetenListe = (funktionalitaetennamen:string[])=>funktionalitaetennamen.map(name=>{return {Funktionalitaet:name};});
    public static setDisabledAttribute = (domElement:JQuery, shouldBeDisabled:boolean)=>domElement.attr("disabled", shouldBeDisabled ? "disabled" : "");

    static getLogoConversionComment = ()=>($("#commentForLogoConversion").val() as string);

    static fillDatenschutzerklaerungWithLink(textWithLinkPlaceholder: string, href: string) {
        const p = HTMLPrinter;
        const matches = new RegExp(/{{(.*)}}/).exec(textWithLinkPlaceholder);

        if(matches !== null && typeof(matches[1]) !== "undefined")
        {
            const linkText = matches[1];
            const link = p.a(p.cssClass("underline"), p.href(href), p.targetNewTag)(linkText);
            $(".accept-privacyterms-label").html(textWithLinkPlaceholder.replace(matches[0], link));
        }
    }

}
